export default __webpack_public_path__ + "096f1ca5914dec45d7709694f486ffab.glb";